import client from '@efex-services/axios';
import { ConfigPaymentButton } from '../types/configPaymentButton.type';

const getConfigPaymentButton = async (
  order_reference: string
): Promise<ConfigPaymentButton> =>
  client.get(`external/payment/${order_reference}/link`);

const ExternalPaymentsSvc = {
  getConfigPaymentButton,
};

export default ExternalPaymentsSvc;
